/** TanStack Query keys + shared bounds for the finance / payouts slice. */

export const PENDING_BALANCES_QUERY_KEY = ["admin", "payouts", "pending-balances"] as const;

export const OWNER_PAYOUTS_QUERY_KEY = ["admin", "venue-owners", "payouts"] as const;

export const OWNER_PAYOUT_PROJECTION_QUERY_KEY = [
  "admin",
  "venue-owners",
  "payouts",
  "projected",
] as const;

/** `POST …/pay` body — `reason` is optional, `@MaxLength(500)`. */
export const PAY_REASON_MAX_LENGTH = 500;

/** `POST …/liquidate` body — `reason` required, 5–500 chars. */
export const LIQUIDATE_REASON_MIN_LENGTH = 5;
export const LIQUIDATE_REASON_MAX_LENGTH = 500;

/** `ManualLedgerEntryDto.reason` (API-FIN-7) — required, 5–500 chars. */
export const CORRECTION_REASON_MIN_LENGTH = 5;
export const CORRECTION_REASON_MAX_LENGTH = 500;

/** `GET …/venue-owners/:id/payouts` — `limit` default 20, API caps at 100. */
export const OWNER_PAYOUTS_LIMIT = 20;
export const OWNER_PAYOUTS_MAX_LIMIT = 100;

/**
 * Options for the `olderThanMonths` report filter (months). `null` = no age
 * filter. Kept small and explicit rather than a free number input.
 */
export const OLDER_THAN_MONTHS_OPTIONS = [1, 3, 6, 12] as const;

/** Tri-state for the `venueOwnerHasConnect` report filter. */
export const CONNECT_FILTERS = ["all", "connected", "not-connected"] as const;
export type ConnectFilter = (typeof CONNECT_FILTERS)[number];

export const LEDGER_QUERY_KEY = ["admin", "ledger"] as const;
export const ACCRUALS_QUERY_KEY = ["admin", "payouts", "accruals"] as const;

/** BO page sizes (API caps: ledger 100, accruals 50). */
export const LEDGER_PAGE_SIZE = 25;
export const ACCRUALS_PAGE_SIZE = 25;

export const MONTHLY_SUMMARY_QUERY_KEY = ["admin", "financial", "monthly-summary"] as const;
export const REVENUE_BY_COUNTRY_QUERY_KEY = ["admin", "financial", "revenue-by-country"] as const;

/**
 * `monthly-summary` totals have no currency field — it's a USD single-currency
 * MVP (API-FIN-6). Render the totals as USD. Revisit when multi-currency ships.
 */
export const FINANCIAL_REPORT_CURRENCY = "usd";
